/**
 * TDEA Radio Header functionality
 * Handles mobile menu toggle and navigation interactions
 */

class TdeARadioHeader {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Toggle menu functionality
    const toggleButton = document.getElementById("tdea-radio-menu-toggle");
    const navList = document.querySelector(".tdea-radio-header__nav-list");

    if (toggleButton && navList) {
      toggleButton.addEventListener("click", () => {
        this.toggleMenu(toggleButton, navList);
      });

      // Close menu when clicking outside
      document.addEventListener("click", (e) => {
        if (!e.target.closest(".tdea-radio-header__nav")) {
          this.closeMenu(toggleButton, navList);
        }
      });

      // Close menu on window resize if open
      window.addEventListener("resize", () => {
        if (window.innerWidth > 768) {
          this.closeMenu(toggleButton, navList);
        }
      });

      // Close menu when pressing Escape key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          this.closeMenu(toggleButton, navList);
        }
      });
    }
  }

  toggleMenu(toggleButton, navList) {
    const isActive = toggleButton.classList.contains("active");

    if (isActive) {
      this.closeMenu(toggleButton, navList);
    } else {
      this.openMenu(toggleButton, navList);
    }
  }

  openMenu(toggleButton, navList) {
    toggleButton.classList.add("active");
    navList.classList.add("active");
    toggleButton.setAttribute("aria-expanded", "true");

    // Prevent body scroll when menu is open
    document.body.style.overflow = "hidden";
  }

  closeMenu(toggleButton, navList) {
    toggleButton.classList.remove("active");
    navList.classList.remove("active");
    toggleButton.setAttribute("aria-expanded", "false");

    // Restore body scroll
    document.body.style.overflow = "";
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new TdeARadioHeader();
});

// Export for potential use in other modules
if (typeof module !== "undefined" && module.exports) {
  module.exports = TdeARadioHeader;
}
